import BigNumber from 'bignumber.js';
import { ICurrentState } from '../../../../reducers/current';

export enum CexOrderType {
  UNDEFINED_TYPE = 0,
  MARKET = 1,
  LIMIT = 2,
}

export interface ICexCoin {
  address: string;
  name: string;
  amount: BigNumber;
}

interface ICexTradingState {
  base: ICexCoin;
  quote: ICexCoin;
  orderType: CexOrderType;
  price: BigNumber;
  buyLoading: boolean;
  sellLoading: boolean;
}

export enum CexTradingAction {
  SetBaseAmount = 'CEX_TRADING_SET_BASE_AMOUNT',
  SetQuoteAmount = 'CEX_TRADING_SET_QUOTE_AMOUNT',
  SetBaseCoin = 'CEX_TRADING_SET_BASE_COIN',
  SetQuoteCoin = 'CEX_TRADING_SET_QUOTE_COIN',
  SetOrderType = 'CEX_TRADING_SET_ORDER_TYPE',
  SetPrice = 'CEX_TRADING_SET_PRICE',
  ToggleBuyLoading = 'CEX_TRADING_TOGGLE_BUY_LOADING',
  ToggleSellLoading = 'CEX_TRADING_TOGGLE_SELL_LOADING',
}

export const getInitialCexTradingState = (
  current: ICurrentState
): ICexTradingState => {
  return {
    base: {
      name: current.base || '',
      address: '',
      amount: new BigNumber(0),
    },
    quote: {
      name: current.quote || '',
      address: '',
      amount: new BigNumber(0),
    },
    orderType: CexOrderType.LIMIT,
    price: new BigNumber(current.price_a),
    buyLoading: false,
    sellLoading: false,
  };
};

export const cexTradingReducer = (
  state: ICexTradingState,
  action: { payload?: any; type: CexTradingAction }
): ICexTradingState => {
  switch (action.type) {
  case CexTradingAction.SetBaseAmount:
    return {
      ...state,
      base: {
        ...state.base,
        amount: new BigNumber(action.payload),
      },
    };
  case CexTradingAction.SetQuoteAmount:
    return {
      ...state,
      quote: {
        ...state.quote,
        amount: new BigNumber(action.payload),
      },
    };
  case CexTradingAction.SetBaseCoin:
    return {
      ...state,
      base: action.payload,
    };
  case CexTradingAction.SetQuoteCoin:
    return {
      ...state,
      quote: action.payload,
    };
  case CexTradingAction.SetOrderType:
    return {
      ...state,
      orderType: action.payload,
    };
  case CexTradingAction.SetPrice:
    return {
      ...state,
      price: action.payload,
    };
  case CexTradingAction.ToggleBuyLoading:
    return {
      ...state,
      buyLoading: !state.buyLoading,
    };
  case CexTradingAction.ToggleSellLoading:
    return {
      ...state,
      sellLoading: !state.sellLoading,
    };
  default:
    return state;
  }
};
